import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initializeThemePreferences } from './lib/theme';
import './index.css';

initializeThemePreferences();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
